module.exports = __webpack_public_path__ + "img/lemomentcapturer_thumbnail.ff3e5d06.jpg";